import { Routes, Route } from 'react-router-dom'

import Customer from 'pages/Customer'
import Customers from 'pages/Customers'
import NotFound from 'pages/NotFound'

const CustomersRouter = () => {
  return (
    <Routes>
      <Route path="/" index element={<Customers />} />
      <Route path=":customerId" element={<Customer />} />
      <Route path=":customerId/systems/:deviceId" >
        <Route path=":activeTab" element={<Customer />} />
        <Route path="" element={<Customer />} />
      </Route>
      <Route path=":customerId/systems/:deviceId/:activeTab" element={<Customer />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default CustomersRouter
